import axios from 'axios';
import config from '../config/apiConfig';

// 1. Configuración de la URL base (Cambia 'localhost' por la IP de tu servidor si es necesario)
const API_URL =  config.api_url + '/api/tienda/configuracion';
const API_URL_PUBLICA =  config.api_url + '/api/tienda/publica/';


/**
 * Obtiene la configuración real desde el backend
 */
export const obtenerConfiguracionTienda = async (slug) => {
    try {
        // Forzamos la barra / entre la URL y el slug para evitar el 404
        const urlFinal = API_URL_PUBLICA.endsWith('/') ? 
                         `${API_URL_PUBLICA}${slug}` : 
                         `${API_URL_PUBLICA}/${slug}`;
        
        console.log("Llamando a API:", urlFinal);
        const response = await axios.get(urlFinal);
        console.log("respuesta", response.data);
        return response.data;
    } catch (error) {
        let errorData = { message: "Error de conexión", status: 500 };

        if (error.response) {
            // El servidor respondió con error (404, 500, etc)
            errorData.message = error.response.data.error || "Tienda no encontrada";
            errorData.status = error.response.status;
        } else {
            errorData.message = error.message;
        }

        console.error("Error en configTiendaApi:", errorData);
        throw errorData; // ESTO ES VITAL para que Pedidos.js lo reciba
    }
};
/**
 * Obtiene la configuración real desde el backend
 */
export const obtenerConfiguracion = async () => {
    try {
        //alert("Llega a obtener el token")
        const token = localStorage.getItem('token'); // Recuperamos tu token de sesión
        console.log("api url", API_URL);
        const response = await axios.get(API_URL, {
            headers: {
                'token': token // Enviamos el token para que getNegocioId() funcione
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error al obtener configuración:", error);
        throw error;
    }
};

/**
 * Guarda los cambios en el backend (PUT)
 */
/**
 * Guarda los cambios en el backend (PUT)
 * @param {FormData} formData - Ahora debe recibir un objeto FormData
 */
export const guardarConfiguracion = async (formData) => {
    try {
        const token = localStorage.getItem('token');
        
        // No definimos 'Content-Type': 'application/json' porque vamos a enviar FormData
        const response = await axios.put(API_URL, formData, {
            headers: {
                'token': token
                // Axios detectará que enviamos FormData y pondrá 'multipart/form-data' automáticamente
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error al guardar configuración:", error);
        throw error;
    }
};

// Mantenemos el alias por compatibilidad con tu componente
export const actualizarConfiguracion = guardarConfiguracion;